import { render, staticRenderFns } from "./BackgroundGraphicAside.vue?vue&type=template&id=4c28c98e&"
import script from "./BackgroundGraphicAside.vue?vue&type=script&lang=js&"
export * from "./BackgroundGraphicAside.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundGraphicAside.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports